export default {
  data: () => ({
    packageItems: [],
    productServices: [],
    orderLines: [],
  }),
  methods: {
    clearOrderLines() {
      this.orderLines.splice(0, this.orderLines.length);
    },
    createOrderLineFromPackage(packageEntity, baseId = 0) {
      this.clearOrderLines();

      const id = baseId + this.orderLines.length + 1;

      const orderLine = {
        id,
        name: packageEntity.name,
        price: packageEntity.price,
        orderableType: 'product',
        orderableUuid: packageEntity.id,
        depth: 1,
        type: 'package',
        requirements: null,
        parentLineId: null,
      };

      this.orderLines.push(orderLine);

      this.packageItems.forEach((packageItem) =>
        this.createOrderLineFromPackageItem(packageItem, id, baseId)
      );
    },
    createOrderLineFromProduct(productEntity, baseId = 0) {
      this.clearOrderLines();

      const id = baseId + this.orderLines.length + 1;

      const orderLine = {
        id,
        name: productEntity.name,
        price: productEntity.price,
        orderableType: 'product',
        orderableUuid: productEntity.id,
        depth: 1,
        type: 'product',
        requirements: null,
        parentLineId: null,
      };

      this.orderLines.push(orderLine);

      this.productServices.forEach((productService) =>
        this.createOrderLineFromProductService(productService, id, baseId)
      );
    },
    createOrderLineFromMembership(productEntity, baseId = 0) {
      this.clearOrderLines();

      const id = baseId + this.orderLines.length + 1;

      const orderLine = {
        id,
        name: productEntity.name,
        price: productEntity.price,
        orderableType: 'product',
        orderableUuid: productEntity.id,
        depth: 1,
        type: 'membership',
        requirements: null,
        parentLineId: null,
      };

      this.orderLines.push(orderLine);
    },
    createOrderLineFromService(serviceEntity, baseId = 0) {
      this.clearOrderLines();

      const id = baseId + this.orderLines.length + 1;

      const orderLine = {
        id,
        name: serviceEntity.name,
        price: serviceEntity.price,
        orderableType: 'product',
        orderableUuid: serviceEntity.id,
        depth: 1,
        type: 'service',
        requirements: null,
        parentLineId: null,
      };

      this.orderLines.push(orderLine);
    },
    createOrderLineFromPackageItem(packageItem, parentLineId, baseId = 0) {
      const id = baseId + this.orderLines.length + 1;

      const orderLine = {
        id,
        name: packageItem.name,
        price: packageItem.price,
        orderableType: 'product',
        orderableUuid: packageItem.productId,
        depth: 2,
        type: 'product',
        requirements: null,
        parentLineId,
      };

      this.orderLines.push(orderLine);

      packageItem.selectedProductServices.forEach((productService) =>
        this.createOrderLineFromProductService(productService, id, baseId)
      );
    },
    createOrderLineFromProductService(productService, parentLineId, baseId = 0) {
      const id = baseId + this.orderLines.length + 1;

      const orderLine = {
        id,
        name: productService.name,
        price: productService.price,
        orderableType: 'product',
        orderableUuid: productService.serviceUuid,
        depth: 3,
        type: 'service',
        requirements: null,
        parentLineId,
      };

      this.orderLines.push(orderLine);
    },
  },
};
